import { AUDIO_ASSET_DEFAULT_PREVIEW_URL } from '../../../../../../constants';
import { SLIDE_TYPE } from '../../constants';

export const defaultAssets = {
    small: AUDIO_ASSET_DEFAULT_PREVIEW_URL,
    medium: AUDIO_ASSET_DEFAULT_PREVIEW_URL,
};

export const enrichMedia = ({ media, type }) => {
    if (type !== SLIDE_TYPE.AUDIO) {
        return media;
    }

    return {
        small: media.small || defaultAssets.small,
        medium: media.medium || defaultAssets.medium,
        original: media.original || media.medium || defaultAssets.medium,
    };
};
